var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
var useDraggableInPortal = function () {
    var self = useRef({}).current;
    useEffect(function () {
        var div = document.createElement('div');
        div.style.position = 'absolute';
        div.style.pointerEvents = 'none';
        div.style.top = '0';
        div.style.width = '100%';
        div.style.height = '100%';
        self.elt = div;
        document.body.appendChild(div);
        return function () {
            document.body.removeChild(div);
        };
    }, [self]);
    return function (render) {
        return function (provided) {
            var args = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args[_i - 1] = arguments[_i];
            }
            var element = render.apply(void 0, __spreadArray([provided], args, false));
            if (provided.draggableProps.style.position === 'fixed') {
                return createPortal(element, self.elt);
            }
            return element;
        };
    };
};
export default useDraggableInPortal;
//# sourceMappingURL=useDraggableInPortal.js.mapvar __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
var useDraggableInPortal = function () {
    var self = useRef({}).current;
    useEffect(function () {
        var div = document.createElement('div');
        div.style.position = 'absolute';
        div.style.pointerEvents = 'none';
        div.style.top = '0';
        div.style.width = '100%';
        div.style.height = '100%';
        self.elt = div;
        document.body.appendChild(div);
        return function () {
            document.body.removeChild(div);
        };
    }, [self]);
    return function (render) {
        return function (provided) {
            var args = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args[_i - 1] = arguments[_i];
            }
            var element = render.apply(void 0, __spreadArray([provided], args, false));
            if (provided.draggableProps.style.position === 'fixed') {
                return createPortal(element, self.elt);
            }
            return element;
        };
    };
};
export default useDraggableInPortal;
//# sourceMappingURL=useDraggableInPortal.js.map